document.addEventListener('DOMContentLoaded', function() {
  const $paymentMethodComponent = $('.payment-method-component');
  const $settingsPage = $('body.settings.show');

  if (!$paymentMethodComponent.length) { return false; }

  const elements = stripe.elements();

  const style = {
    base: {
      color: '#32325d',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4'
      }
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a'
    }
  };

  const card = elements.create('card', { style: style });

  function mountCardElement() {
    card.mount('#card-input-element');
    card.addEventListener('change', function (e) {
      showCardError(e.error);
    });
  }

  function toggleView() {
    $paymentMethodComponent.find('.payment-method-select').toggle();
    $paymentMethodComponent.find('.payment-method-create').toggle();
  }

  function handleToggleViewClick(e) {
    e.preventDefault();

    toggleView();
  }

  function successFlash() {
    $('body').trigger('flashmessage', ['notice', 'Payment Method succesfully created.']);
  }


  function showCardError(error) {
    if (error) {
      $('#card-errors').text(error.message);
    } else {
      $('#card-errors').text('');
    }
  }

  function onSaveError(response) {
    if (response.responseJSON && response.responseJSON.error) {
      showCardError({ message: response.responseJSON.error });
    } else {
      showCardError({ message: 'Error encountered while processing this card.' });
    }
    enableCardSubmit();
  }

  function onSaveSuccess(result) {

    var $paymentMethodSelect = $('select#payment_method_id', $paymentMethodComponent);

      $('option', $paymentMethodSelect).each(function() {
        $(this).attr('selected', false);
      });

      $paymentMethodSelect.append($('<option>', {
        value: result.id,
        text: result.display_name,
        'data-external-id': result.external_id,
        selected: 'selected'
      }));

    successFlash()
    mountCardElement();
    if (!$settingsPage.length) {
      toggleView();
    } else {
      setTimeout(
        function() {
          }, 3000
        );
        location.reload();
    }
    enableCardSubmit();
  }

  function createPaymentMethod(token) {
    var url = '/payment_methods';

    if ($('only-create').length) {
      injectAndPostForm(url, token.id);
    } else {
      ajaxPost(url, token.id);
    }
  }

  function ajaxPost(url, stripe_token_id) {
    $.ajax({
      url: url,
      method: 'POST',
      dataType: 'json',
      data: { stripe_token_id: stripe_token_id }
    }).success(onSaveSuccess)
      .error(onSaveError);
  }

  function injectAndPostForm(url, stripe_token_id) {
    var $form = $('<form>', {
      action: url,
      method: 'POST'
    });

    $('<input>').attr({
      type: 'hidden',
      name: 'stripe_token_id',
      value: stripe_token_id
    }).appendTo($form);

    $('<input>').attr({
      type: 'hidden',
      name: 'authenticity_token',
      value: $('meta[name=csrf-token]').attr('content')
    }).appendTo($form);

    $form.appendTo('body').submit();
  }

  function createStripeCard(successCallback) {
    const nameOnCard = $('#cardholder_name').val();

    stripe.createToken(card, { name: nameOnCard })
      .then(function(result) {
        if (result.error) {
          showCardError(result.error);
          enableCardSubmit();
        } else {
          successCallback(result.token);
        }
      });
  }

  function disableCardSubmit() {
    const $cardSubmit = $('#card-save');

    $cardSubmit.prop('disabled', true);
    $cardSubmit.data('prompt', $cardSubmit.html());
    $cardSubmit.html($cardSubmit.data('disableWith'));
  }

  function enableCardSubmit() {
    const $cardSubmit = $('#card-save');

    $cardSubmit.prop('disabled', false);
    $cardSubmit.html($cardSubmit.data('prompt'));
  }

  mountCardElement();

  $paymentMethodComponent.on('click', '.toggle-view', handleToggleViewClick);

  $paymentMethodComponent.on('click', '#card-save', function(e) {
    e.preventDefault();

    if ($('#card-save').prop('disabled')) { return false; }
    disableCardSubmit();

    createStripeCard(createPaymentMethod);
  });
});
